export default {
  notification: 'Notification',
  yes: 'Yes',
  no: 'No',
  male: 'Male',
  female: 'Female',
}
